<router-outlet />
@if (isLoading$ | async) {
  <vdms-hq-ui-loader [center]="true" [backdrop]="true" mode="over" />
}
<vdms-hq-toast-messages />
